import {Component, h} from "preact";
import styles from './style.module.scss';
import {icons} from "../icons";
import {FilterMap, ProductFilter} from "../../models/filter";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import FilterGroup from "../filter-group";
import Filter from "../filter";
import {Like} from "../../models/customer";
import {i18nService} from "../../services/i18n-service";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {FilterType} from "../../models/product";
import {QueryState} from "../../models/query";
import {config} from "../../config";

export interface Props {
  toggleIsFilterDisplayed(show?: boolean);

  initStore(filterMap: FilterMap);

  clearAllFilters();

  isFilterDisplayed?: boolean;
  filters?: FilterMap;
  likes: Like[];
  isMobile: boolean;
  products: QueryState;
}

const mapToProps = ({isFilterDisplayed, filters, likes, products}) => ({
  isFilterDisplayed,
  filters,
  likes,
  products
});

class ListFilter extends Component<Props, any> {

  componentDidMount(): void {
    if (this.props.isMobile) {
      this.props.toggleIsFilterDisplayed(false);

    } else {
      this.props.toggleIsFilterDisplayed(true);
      //enables scrolling on desktop since the filter is always shown
      document.body.style.overflow = 'visible';
      document.documentElement.style.overflow = 'auto';
    }
  }

  componentWillUnmount() {
    //enables scrolling if component unmounted
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = 'auto';
  }

  handleFilterClick() {
    this.props.toggleIsFilterDisplayed();
    if (this.props.isMobile) {
      document.body.style.overflow = 'visible';
      document.documentElement.style.overflow = 'hidden';
    }
  }

  render() {
    if (!this.props.filters) {
      return;
    }

    return (
      <div class={`${styles['filter-container']} ${this.props.isFilterDisplayed ? styles.show : ''}`}
           onClick={this.props.isMobile ? this.handleCloseBackground.bind(this) : undefined}>
        <div id={'filter-content'}
             class={`${styles['filter-content']} ${this.props.isFilterDisplayed ? styles.show : ''}`}>
          <div class={styles['filter-header']}>
            <div class={styles.close}>
              <span onClick={() => this.props.toggleIsFilterDisplayed()}>{icons.renderCloseIcon()}</span>
            </div>
            <div class={styles.header}>
              <div class={styles.filters}>
                <div class={styles['current-filter']}>
                  <div onClick={() => this.handleFilterClick}>
                    <span>{i18nService.translate('list_filter_title')} ({this.props.filters.selected.length}) {icons.renderCaretUpIcon()}</span>
                  </div>
                </div>
                <div class={styles['delete-filters']}>
                  <a href={config.url(this.props.filters.getCleanFilterUrl())}>{i18nService.translate('list_clear_all_filters')} {icons.renderTrashIcon()}</a>
                </div>
              </div>
            </div>
          </div>
          <div class={styles['filter-body']}>

            <div class={styles['custom-filters']}>
              {this.props.filters.custom.map((filter: ProductFilter) => {
                return <Filter filter={filter} isCustomFilter={true}/>
              })}
            </div>

            <div class={styles.likes}>
              {this.props.filters.likes.map((filter: ProductFilter) => {
                return <Filter filter={filter}/>
              })}
            </div>

            <div class={styles['default-filters']}>
              {this.props.filters.editorials.length > 0 &&
                <FilterGroup filters={this.props.filters.editorials} gender={this.props.filters.gender}
                             headlineKey={'filter_headline_editorials'}/>}
              {this.props.filters.categories.length > 0 && !this.props.filters.selected.find(it => it.type == FilterType.Editorial) &&
                <FilterGroup filters={this.props.filters.categories} gender={this.props.filters.gender}
                             headlineKey={'filter_headline_categories'}/>}
              {this.props.filters.brands.length > 0 && !this.props.filters.selected.find(it => it.type == FilterType.Editorial) &&
                <FilterGroup filters={this.props.filters.brands} gender={this.props.filters.gender}
                             headlineKey={'filter_headline_brands'}/>}
              {!this.props.filters.selected.find(it => it.type == FilterType.Editorial) &&
                <FilterGroup sort={true} filters={this.props.filters.colors} gender={this.props.filters.gender}
                             headlineKey={'filter_headline_colors'}/>}
            </div>
          </div>
        </div>
        {this.props.filters.selected.length > 0 && <div class={styles['filter-footer']}>
          <button onClick={() => this.props.toggleIsFilterDisplayed()} class={styles['product-count-button']}>
            {i18nService.translate("list_button_product_count", this.props.products.totalCount.toString())}
          </button>
        </div>}
      </div>
    )
  }

  private handleCloseBackground(e: Event) {
    if (e.target === e.currentTarget) {
      this.props.toggleIsFilterDisplayed();
    }
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(ListFilter))
